import {defineMessages} from 'react-intl';

export default defineMessages({
	returnNotAvailable: {
		id: 'returnAuthCreateForm.step1.returnNotAvailable',
		defaultMessage: 'This item is not eligible for return',
	},
});